import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles({
  /**
   * Inset by the same 16px the toolbar below carries, so the first card's left edge and the last
   * card's right edge line up with the search field and the buttons rather than running to the
   * container's edges.
   */
  /**
   * Six tiles sized to fit one row. The overflow rule is not dead weight: it is what keeps a
   * narrow viewport, a longer figure or a seventh tile from either wrapping a lone card onto a
   * second row that reads as a different section, or squeezing the 24px figures below the size
   * they are legible at.
   */
  kpiRow: {
    display: 'flex',
    gap: 16,
    padding: '0 16px',
    marginBottom: 16,
    overflowX: 'auto',
    // The cards carry their own background; without this the scroll edge cuts through their border.
    paddingBottom: 4,
    scrollSnapType: 'x proximity',
    WebkitOverflowScrolling: 'touch',
    /** Quiet until used: a scrollbar sitting under the tiles reads as a divider. */
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      height: 6
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: palette.shades[300],
      borderRadius: 3
    }
  },
  kpiCard: {
    padding: '12px 16px',
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: 4,
    backgroundColor: palette.common.white,
    /**
     * Six across the first view: each takes a sixth of the row, less its share of the five 16px gaps.
     * `flex` rather than a width so they still fill a wider viewport instead of leaving a gap at the
     * end, and `flexShrink: 0` so a seventh tile pushes into the scroll rather than squeezing the six.
     */
    flex: '0 0 calc((100% - 80px) / 6)',
    minWidth: 150,
    scrollSnapAlign: 'start'
  },
  kpiLabel: {
    color: palette.shades[700],
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    fontSize: 11,
    lineHeight: '16px',
    marginBottom: 4
  },
  /**
   * The line box is fixed rather than left to the glyph: an em dash and a digit have very different
   * natural heights, so without it the placeholder cards sit a few pixels off from the real one and
   * the row of four stops reading as a row.
   */
  kpiValue: {
    fontSize: 24,
    lineHeight: '30px',
    fontWeight: 600,
    color: palette.shades[900]
  },
  /** Reads as absent rather than as zero: a figure we cannot compute is not a figure of nought. */
  kpiValueUnavailable: {
    color: palette.shades[500]
  },
  kpiHint: {
    color: palette.shades[700],
    lineHeight: '18px',
    marginTop: 2
  }
});
export default useStyles;